import React from 'react';

import cn from '~/Utils/cn';

interface WrapFieldWithAsteriskProps {
  showAsterisk?: boolean;
  asteriskClassName?: string;
  children: React.ReactNode;
}

const WrapFieldWithAsterisk: React.FC<WrapFieldWithAsteriskProps> = ({ showAsterisk, asteriskClassName, children }) => {
  if (!showAsterisk) {
    return <>{children}</>;
  }

  return (
    <div className="relative w-full">
      <span className={cn(`absolute -left-8 top-2/3 mr-4 -translate-y-1/2 font-bold text-red-700`, asteriskClassName)}>
        *
      </span>
      <div className="w-full">{children}</div>
    </div>
  );
};

export default WrapFieldWithAsterisk;
